import React from "react";

import { Box } from "~components/Box";
import { ButtonLink } from "~components/ButtonLink";
import { StoryblokRichText } from "~components/StoryblokRichText";

import { type CallOut as CallOutProps } from "../Nav.types";
import { navigationMenuCallout } from "./styles.css";

export function Callout({
  description,
  ctaText,
  link,
  darkMode,
}: CallOutProps) {
  return (
    <Box className={navigationMenuCallout({ darkMode })}>
      <StoryblokRichText text={description} />
      <ButtonLink
        link={link}
        fontWeight="bold"
        background={darkMode ? "background_charcoal" : "background_lavender"}
      >
        {ctaText}
      </ButtonLink>
    </Box>
  );
}
